/**
 * A row of equal-width preset buttons, one highlighted as selected --
 * shared by the Create/Edit trip modals' cadence-minutes, cadence-mode and
 * grace-window pickers. Mirrors the Android app's own preset chips
 * (CreateTripScreen/EditTripScreen).
 *
 * @param {string} label - Section heading above the row
 * @param {{value: string|number, label: string}[]} options
 * @param {string|number} value - The currently selected option's value
 * @param {(value: string|number) => void} onChange
 */
export default function CheckerPresetRow({ label, options, value, onChange }) {
    return (
        <div className="checker-preset-group">
            <div className="checker-preset-label">{label}</div>
            <div className="checker-preset-row">
                {options.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        className={`checker-preset-button${
                            option.value === value ? " checker-preset-button-selected" : ""
                        }`}
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    )
}
